import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import me from '@/plugins/graphql/queries/me.gql';
import ActionButton from '@/components/action_button/Index.vue';
import BaseTextField from '@/components/v2/BaseTextField.vue';
import { required, email } from 'vuelidate/lib/validators';
import { CG_CMS_BASE } from '@/helpers/constants/app';
import FormValidationsMixin from '@/helpers/vue_mixins/v2/FormValidationsMixin';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import FormMixin from '@/helpers/vue_mixins/FormMixin';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import CreateAffiliateInvite from '@/plugins/graphql/mutations/v2/create-affiliate-invite.gql';
import SalesPartnerInvites from '@/plugins/graphql/queries/v2/sales-partner-invites.gql';
import NetworkDistributorMixin from '@/helpers/vue_mixins/v2/network_distributor/NetworkDistributorMixin';
let AffiliateInviteForm = class AffiliateInviteForm extends Mixins(FormValidationsMixin, AlertMixin, FormMixin, ViewportSizeMixin, NetworkDistributorMixin) {
    constructor() {
        super(...arguments);
        this.mutationRequestOnFlight = false;
        this.form = {
            userUuid: '',
            email: '',
        };
    }
    get shareLink() {
        return `${CG_CMS_BASE}/sales?affiliate_code=${this.me?.affiliateCode}`;
    }
    copyToClipboard() {
        const self = this;
        const text = this.shareLink;
        if (text) {
            const input = document.createElement('input');
            input.setAttribute('value', text);
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
            self.successNotification('Copied to Clipboard!');
        }
    }
    async create() {
        const userUuid = this.$route.params.resellerUuid;
        await this.$apollo.mutate({
            mutation: CreateAffiliateInvite,
            variables: {
                input: {
                    userUuid,
                    email: this.form.email,
                },
            },
            update(cache, { data }) {
                const queryOptions = {
                    query: SalesPartnerInvites,
                    variables: {
                        userUuid,
                    },
                };
                const { salesPartnerInvites } = cache.readQuery({ ...queryOptions });
                const cachedSalesPartnerInvites = {
                    ...salesPartnerInvites,
                };
                cachedSalesPartnerInvites.edges.unshift({
                    node: data.createAffiliateInviteLog.affiliateInviteLog,
                });
                cache.writeQuery({
                    ...queryOptions,
                    data: {
                        salesPartnerInvites: cachedSalesPartnerInvites,
                    },
                });
            },
        });
    }
    async onSubmit() {
        this.$v.$touch();
        const mutation = () => {
            return this.create();
        };
        if (!this.$v.$invalid) {
            this.mutationRequestOnFlight = !this.mutationRequestOnFlight;
            await mutation()
                .then(() => {
                this.successNotification('Invitation Sent');
            })
                .catch((e) => {
                this.errorNotification(e.message);
            })
                .finally(() => {
                this.resetForm();
                this.mutationRequestOnFlight = !this.mutationRequestOnFlight;
            });
        }
    }
    get isReseller() {
        return this.me?.role === 'reseller';
    }
};
AffiliateInviteForm = __decorate([
    Component({
        apollo: {
            me: {
                query: me,
                skip() {
                    return !this.$store.state.session.token;
                },
            },
        },
        components: {
            ActionButton,
            BaseTextField,
        },
        validations: {
            form: {
                email: { email, required },
            },
        },
    })
], AffiliateInviteForm);
export default AffiliateInviteForm;
